/**
 * @generated SignedSource<<33af42243629c37e95ce6d8e69d186e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceByYearLineItem_component$data = {
  readonly development: any;
  readonly period: string;
  readonly " $fragmentType": "PerformanceByYearLineItem_component";
};
export type PerformanceByYearLineItem_component$key = {
  readonly " $data"?: PerformanceByYearLineItem_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceByYearLineItem_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceByYearLineItem_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "development",
      "storageKey": null
    }
  ],
  "type": "PerformanceByYearLineItem",
  "abstractKey": null
};

(node as any).hash = "e9a9f5783c93735aab1a041f1597f1cc";

export default node;
